// Normalizes a user-entered website into something Django's URLField accepts.
// Members routinely type a bare domain ("company.com", "www.company.com"); the
// backend rejects those as "Enter a valid URL." Prepend https:// when no scheme
// is present. A blank value stays blank (the field is optional).
export function normalizeUrl(input?: string | null): string {
  const value = (input || '').trim();
  if (!value) return '';
  if (/^[a-z][a-z0-9+.-]*:\/\//i.test(value)) return value;
  return `https://${value}`;
}
